import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'react-emotion';

export class Radio extends React.Component {
  render() {
    const { name, selectedValue, onChange } = this.context.radioGroup;
    const { label,  value } = this.props;
    const optional = {};
    if(selectedValue !== undefined) {
      optional.checked = (value === selectedValue);
    }
    if(typeof onChange === 'function') {
      optional.onChange = onChange;
    }

    const statusClassName = optional.checked ? 'opt-choosen' : 'opt-unchoosen';

    return (
      <label htmlFor={this.id}>
        <div className="radio-option-wrapper">
          <span className="radio-icon-wrapper">
            <input id={this.id} type="radio" name={name} {...this.props} label={undefined} {...optional} />
            <span className={`radio-btn ${statusClassName}`} />
          </span>
          <span className="option-label">{label}</span>
        </div>
    </label>
    );
  }
}

Radio.contextTypes = {
  radioGroup: PropTypes.object
};
Radio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.any
};

export class RadioGroup extends React.Component {
  getChildContext() {
    const { name, selectedValue, onChange } = this.props;
    return {
      radioGroup: {
        name, selectedValue, onChange
      }
    }
  }

  render() {
    const { Component, name, selectedValue, onChange, children, vertical, className = '', ...rest } = this.props;
    const classNames = `${className} ${vertical ? verticalClass : ''}`;
    return <Component {...rest} className={classNames}>{children}</Component>;
  }
}

RadioGroup.defaultProps = {
  Component: "div"
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  selectedValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  Component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
  ])
};

RadioGroup.childContextTypes = {
  radioGroup: PropTypes.object
};

const verticalClass = css`
  .radio-option-wrapper {
    display: block;
  }
`;


// WEBPACK FOOTER //
// ./src/components/form/RadioGroup.jsx